module.exports = __webpack_public_path__ + "08af2c8f984fe2599db88714c66c4a5c.pdf";